import React, { useEffect, useState } from "react";
import { Button, Input, Select } from "antd";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

function AuxilaryEngine({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [number_of_auxiliary_engines, set_number_of_auxiliary_engines] = useState("1");
  const [auxiliary_engine_make, set_auxiliary_engine_make] = useState("");
  const [auxiliary_engine_model, set_auxiliary_engine_model] = useState("");
  const [auxiliary_engine_power_rating, set_auxiliary_engine_power_rating] = useState("");
  const [auxiliary_no_of_cylinder, set_auxiliary_no_of_cylinder] = useState("");
  const [select_engine_number, set_select_engine_number] = useState("");

  const ADD_API = () => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("number_of_auxiliary_engines", number_of_auxiliary_engines);
      FORM_DATA.append("auxiliary_engine_model", auxiliary_engine_model);
      FORM_DATA.append("auxiliary_engine_make", auxiliary_engine_make);
      FORM_DATA.append("auxiliary_engine_power_rating", auxiliary_engine_power_rating);
      FORM_DATA.append("auxiliary_no_of_cylinder", auxiliary_no_of_cylinder);
      FORM_DATA.append("request_type", "add-edit");
      post(ApiURL.ship_auxi_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Congratulation!!", res?.message);
          set_loader(false);
          if (onSuccess) onSuccess();
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } catch (error) {
      set_loader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const VIEW_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("request_type", "view");
      FORM_DATA.append("auxi_engine_number", number_of_auxiliary_engines || select_engine_number);
      post(ApiURL.ship_auxi_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_auxiliary_engine_make(res?.auxi_data?.auxiliary_engine_make);
          set_auxiliary_engine_model(res?.auxi_data?.auxiliary_engine_model);
          set_auxiliary_engine_power_rating(res?.auxi_data?.auxiliary_engine_power_rating);
          set_auxiliary_no_of_cylinder(res?.auxi_data?.auxiliary_no_of_cylinder);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } finally {
    }
  };

  useEffect(() => {
    if (select_engine_number) {
      set_auxiliary_engine_make("");
      set_auxiliary_engine_model("");
      set_auxiliary_engine_power_rating("");
      set_auxiliary_no_of_cylinder("");
    }
  }, [select_engine_number]);

  useEffect(() => {
    if (id) {
      VIEW_API();
    }
  }, [id, select_engine_number]);

  return (
    <>
      <h3 style={{ marginTop: "15px" }}>Auxiliary Engine Details</h3>
      <div className="row">
        {/* no. of auxilary engine  */}
        <div className="col-6">
          <div className="input-box">
            <label>Number of auxiliary engine</label>
            <Select
              value={number_of_auxiliary_engines}
              placeholder="--count of auxiliary engine --"
              style={{ width: "100%" }}
              onChange={(value) => {
                set_select_engine_number(value);
                set_number_of_auxiliary_engines(value);
              }}
            >
              <Select.Option value="1">1</Select.Option>
              <Select.Option value="2">2</Select.Option>
              <Select.Option value="3">3</Select.Option>
              <Select.Option value="4">4</Select.Option>
            </Select>
            {errors?.number_of_auxiliary_engines && (
              <>
                <span style={{ color: "red" }}>{errors?.number_of_auxiliary_engines}</span>
              </>
            )}
          </div>
        </div>
        {/*auxiliary engine make*/}
        <div className="col-6">
          <div className="input-box">
            <label>Auxiliary engine make</label>
            <Input
              value={auxiliary_engine_make}
              placeholder="Auxiliary engine make"
              onChange={(e) => set_auxiliary_engine_make(e.target.value)}
            />
            {errors?.auxiliary_engine_make && (
              <>
                <span style={{ color: "red" }}>{errors?.auxiliary_engine_make}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        {/* auxiliary engine model */}
        <div className="col-6">
          <div className="input-box">
            <label>Auxiliary engine model</label>
            <Input
              value={auxiliary_engine_model}
              placeholder=" Auxiliary engine model "
              onChange={(e) => set_auxiliary_engine_model(e.target.value)}
            />
            {errors?.auxiliary_engine_model && (
              <>
                <span style={{ color: "red" }}>{errors?.auxiliary_engine_model}</span>
              </>
            )}
          </div>
        </div>
        {/* auxiliary engine power rating */}
        <div className="col-6">
          <div className="input-box">
            <label>Auxiliary engine power rating</label>
            <Input
              value={auxiliary_engine_power_rating}
              placeholder="Auxiliary engine power rating"
              onChange={(e) => set_auxiliary_engine_power_rating(e.target.value)}
            />
            {errors?.auxiliary_engine_power_rating && (
              <>
                <span style={{ color: "red" }}>{errors?.auxiliary_engine_power_rating}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        {/* No. of auxilary cylinder */}
        <div className="col-6">
          <div className="input-box">
            <label>Number of Cylinder</label>
            <Select
              value={auxiliary_no_of_cylinder}
              placeholder=" ---- count of cylinder ----"
              style={{ width: "100%" }}
              onChange={(value) => set_auxiliary_no_of_cylinder(value)}
            >
              {Array.from({ length: 10 }, (_, i) => (
                <Select.Option key={i + 1} value={i + 1}>
                  {i + 1}
                </Select.Option>
              ))}
            </Select>
            {errors?.auxiliary_no_of_cylinder && (
              <>
                <span style={{ color: "red" }}>{errors?.auxiliary_no_of_cylinder}</span>
              </>
            )}
          </div>
        </div>
      </div>
      <br />
      <div className="input-box" style={{ marginTop: "15px" }}>
        <Button type="primary" onClick={ADD_API} loading={loader}>
          save
        </Button>
      </div>
    </>
  );
}

export default AuxilaryEngine;
